import TagInputPicker from './TagInputPicker';
import { normalizeFieldText } from '../utils/textCase';

/**
 * Multi-select preferred work locations — advanced portaled picker.
 */
export default function PreferredWorkLocationsPicker({
  selectedLocations = [],
  onChange,
  catalog = [],
  error,
  hint = 'Search locations, pick from the list, or add a new one.',
  showCountBadge = true,
  menuZIndex
}) {
  const normalizeLocation = loc =>
    normalizeFieldText(String(loc || '').trim(), 'name');

  return (
    <TagInputPicker
      variant="location"
      selected={selectedLocations}
      onChange={onChange}
      catalog={catalog}
      error={error}
      hint={hint}
      showCountBadge={showCountBadge}
      label="Add location"
      placeholder="Search or type a location (e.g. Delhi, Bengaluru)…"
      menuZIndex={menuZIndex}
      normalizeItem={normalizeLocation}
    />
  );
}
